import { render, staticRenderFns } from "./CardLegalEditor.vue?vue&type=template&id=b115f30a&"
import script from "./CardLegalEditor.vue?vue&type=script&lang=js&"
export * from "./CardLegalEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports